let installPromptEvent = null;
let toastEl = null;

const STORAGE_KEY = "pwa_install_dismissed_until";
const DISMISS_DAYS = 10;
const NombreApp = "ConectarApp";

const colorBtn = "#f06f23"; // color principal de la app #007bbe
const colorBtnText = "#ffffff";
function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function isSafari() {
  // Safari iOS y macOS (bastante aproximado)
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function isIOSStandaloneCapable() {
  // iOS Safari no dispara beforeinstallprompt, pero permite "Add to Home Screen"
  return isIOS() && isSafari();
}

function getDismissedUntil() {
  const v = localStorage.getItem(STORAGE_KEY);
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function dismissForDays(days = DISMISS_DAYS) {
  const until = Date.now() + days * 24 * 60 * 60 * 1000;
  localStorage.setItem(STORAGE_KEY, String(until));
}

function isDismissed() {
  return Date.now() < getDismissedUntil();
}

function removeToast() {
  if (!toastEl) return;
  toastEl.remove();
  toastEl = null;
}

function hideToast() {
  if (!toastEl) return;

  toastEl.classList.remove("pwa-toast-show");
  toastEl.classList.add("pwa-toast-hide");

  setTimeout(() => {
    if (toastEl) toastEl.style.display = "none";
  }, 220);
}

function showToast() {
  if (!toastEl) createToast();

  if (isStandalone()) return;
  if (isDismissed()) return;

  const canShowIOSGuide = isIOSStandaloneCapable();
  const canShowInstallPrompt = !!installPromptEvent;

  if (!canShowIOSGuide && !canShowInstallPrompt) return;

  // Ajustamos contenido según plataforma
  setToastMode(canShowIOSGuide ? "ios" : "install");

  toastEl.style.display = "flex";

  // reset clases
  toastEl.classList.remove("pwa-toast-hide");

  void toastEl.offsetHeight;
  toastEl.classList.add("pwa-toast-show");
}

function setToastMode(mode) {
  // mode: "install" | "ios"
  const title = toastEl.querySelector("[data-title]");
  const subtitle = toastEl.querySelector("[data-subtitle]");
  const installBtn = toastEl.querySelector("[data-install-btn]");

  if (mode === "ios") {
    title.textContent = `Instalá ${NombreApp}`;
    subtitle.textContent = "En iPhone: Compartir → Añadir a pantalla de inicio";
    installBtn.style.display = "none"; // en iOS no hay prompt automático
  } else {
    title.textContent = `Instalá ${NombreApp}`;
    subtitle.textContent = "Acceso rápido desde tu pantalla de inicio.";
    installBtn.style.display = "inline-flex";
  }
}

function createToast() {
  if (toastEl) return toastEl;

  // estilos + animación con CSS inyectado
  const style = document.createElement("style");
  style.textContent = `
    #pwa-install-toast {
      position: fixed;
      right: 16px;
      bottom: calc(16px + env(safe-area-inset-bottom, 0px) + 12px);
      z-index: 99999;
      max-width: 340px;
      width: calc(100% - 32px);
      display: none;
      align-items: center;
      gap: 12px;
      padding: 12px 12px;
      border-radius: 16px;
      background: #111827;
      color: #fff;
      box-shadow: 0 10px 30px rgba(0,0,0,0.35);
      font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, "Helvetica Neue", Arial;
      transform: translateY(16px);
      opacity: 0;
      pointer-events: none;
    }

    #pwa-install-toast.pwa-toast-show {
      animation: pwaToastIn 220ms ease-out forwards;
      pointer-events: auto;
    }

    #pwa-install-toast.pwa-toast-hide {
      animation: pwaToastOut 200ms ease-in forwards;
      pointer-events: none;
    }

    @keyframes pwaToastIn {
      from { transform: translateY(16px); opacity: 0; }
      to   { transform: translateY(0px); opacity: 1; }
    }

    @keyframes pwaToastOut {
      from { transform: translateY(0px); opacity: 1; }
      to   { transform: translateY(16px); opacity: 0; }
    }

    #pwa-install-toast .pwa-content {
      display: flex;
      flex-direction: column;
      gap: 2px;
      flex: 1;
      min-width: 0;
    }

    #pwa-install-toast .pwa-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    #pwa-install-toast .pwa-subtitle {
      font-size: 12px;
      opacity: 0.85;
      line-height: 1.2;
    }

    #pwa-install-toast .pwa-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
    }

    #pwa-install-toast .pwa-install-btn {
      border: none;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 999px;
      font-size: 13px;
      font-weight: 700;
      background: ${colorBtn};
      color: ${colorBtnText};
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }

    #pwa-install-toast .pwa-close-btn {
      border: none;
      cursor: pointer;
      width: 32px;
      height: 32px;
      border-radius: 999px;
      font-size: 14px;
      font-weight: 700;
      background: rgba(255,255,255,0.12);
      color: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    @media (max-width: 480px) {
      #pwa-install-toast {
        left: 16px;
        right: 16px;
        max-width: none;
        bottom: calc(16px + env(safe-area-inset-bottom, 0px) + 18px);
      }
    }
  `;
  document.head.appendChild(style);

  toastEl = document.createElement("div");
  toastEl.id = "pwa-install-toast";

  const content = document.createElement("div");
  content.className = "pwa-content";

  const title = document.createElement("div");
  title.className = "pwa-title";
  title.setAttribute("data-title", "1");

  const subtitle = document.createElement("div");
  subtitle.className = "pwa-subtitle";
  subtitle.setAttribute("data-subtitle", "1");

  content.appendChild(title);
  content.appendChild(subtitle);

  const actions = document.createElement("div");
  actions.className = "pwa-actions";

  const installBtn = document.createElement("button");
  installBtn.type = "button";
  installBtn.className = "pwa-install-btn";
  installBtn.setAttribute("data-install-btn", "1");
  installBtn.innerHTML = "📲 Instalar";

  const closeBtn = document.createElement("button");
  closeBtn.type = "button";
  closeBtn.className = "pwa-close-btn";
  closeBtn.setAttribute("aria-label", "Cerrar");
  closeBtn.textContent = "✕";

  installBtn.addEventListener("click", async () => {
    if (!installPromptEvent) return;

    installPromptEvent.prompt();
    const choice = await installPromptEvent.userChoice;

    if (choice.outcome === "accepted") {
      //console.log("acepto inst");
      hideToast();
    } else {
      console.log("rechazo inst");
      dismissForDays();
      hideToast();
    }

    installPromptEvent = null;
  });

  closeBtn.addEventListener("click", () => {
    dismissForDays();
    hideToast();
  });

  actions.appendChild(installBtn);
  actions.appendChild(closeBtn);

  toastEl.appendChild(content);
  toastEl.appendChild(actions);

  document.body.appendChild(toastEl);

  title.textContent = `Instalá ${NombreApp}`;
  subtitle.textContent = "Acceso rápido desde tu pantalla de inicio.";

  return toastEl;
}

window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  installPromptEvent = event;
  showToast();
});

window.addEventListener("appinstalled", () => {
  console.log("🎉 App instalada");
  installPromptEvent = null;
  removeToast();
});

document.addEventListener("DOMContentLoaded", () => {
  if (isStandalone()) return;
  createToast();

  // iOS: mostramos guía aunque no exista beforeinstallprompt
  if (isIOSStandaloneCapable() && !isDismissed()) {
    showToast();
  }
});
